/**
 * @generated SignedSource<<0f9da99c177010a1ca0a3665bc420e8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SchoolExamScrapDeleteInput = {
  id: string;
};
export type SchoolExamSourceId_schoolExamScrapDeleteMutation$variables = {
  input: SchoolExamScrapDeleteInput;
};
export type SchoolExamSourceId_schoolExamScrapDeleteMutation$data = {
  readonly schoolExamScrapDelete: {
    readonly id: string;
  };
};
export type SchoolExamSourceId_schoolExamScrapDeleteMutation = {
  response: SchoolExamSourceId_schoolExamScrapDeleteMutation$data;
  variables: SchoolExamSourceId_schoolExamScrapDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SchoolExamSourceId_schoolExamScrapDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamScrap",
        "kind": "LinkedField",
        "name": "schoolExamScrapDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SchoolExamSourceId_schoolExamScrapDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SchoolExamScrap",
        "kind": "LinkedField",
        "name": "schoolExamScrapDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72d50695020abc131449de7ad0150c56",
    "id": null,
    "metadata": {},
    "name": "SchoolExamSourceId_schoolExamScrapDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation SchoolExamSourceId_schoolExamScrapDeleteMutation(\n  $input: SchoolExamScrapDeleteInput!\n) {\n  schoolExamScrapDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "105ff9ce9a03597be30d93251c81356f";

export default node;
